module.exports = __webpack_public_path__ + "static/media/Desktop-Lines-Bottom.293ddf93.png";